import { webAudioContext } from "./webaudio_context";
import { webAudioUtils } from "./webaudio_utils";
import { NodeHtml } from "./node_html";

class NodePingPongDelayHtml extends NodeHtml {
  handlers = this.extendParentHandlers({
    volume: { handler: this.setVolume, type: "float", default: 0, min: -80, max: 12 },
    delayTime: { handler: this.setDelayTime, type: "float", default: 1200, min: 1, max: 180000 },
  });

  setProps(dnode) {
    const delayTime = dnode.props.delayTime / 1000;
    const feedback = webAudioUtils.dbToJs(dnode.props.feedback);
    const channelCountMode = "explicit";
    const channelCount = 1;

    dnode.delayLeft = webAudioContext.context.createDelay();
    dnode.delayLeft.channelCountMode = channelCountMode;
    dnode.delayLeft.channelCount = channelCount;
    dnode.delayLeft.delayTime.value = delayTime;

    dnode.feedbackLR = webAudioContext.context.createGain();
    dnode.feedbackLR.channelCountMode = channelCountMode;
    dnode.feedbackLR.channelCount = channelCount;
    dnode.feedbackLR.gain.value = feedback;

    dnode.delayRight = webAudioContext.context.createDelay();
    dnode.delayRight.channelCountMode = channelCountMode;
    dnode.delayRight.channelCount = channelCount;
    dnode.delayRight.delayTime.value = delayTime;

    dnode.feedbackRL = webAudioContext.context.createGain();
    dnode.feedbackRL.channelCountMode = channelCountMode;
    dnode.feedbackRL.channelCount = channelCount;
    dnode.feedbackRL.gain.value = feedback;

    dnode.outputMerge = webAudioContext.context.createChannelMerger(2);
    dnode.wetGain = webAudioContext.context.createGain();
    dnode.wetGain.gain.value = webAudioUtils.dbToJs(dnode.props.wetLevel);

    dnode.input = webAudioContext.context.createGain();
    dnode.output = webAudioContext.context.createGain();
    dnode.dryGain = webAudioContext.context.createGain();
    dnode.dryGain.gain.value = webAudioUtils.dbToJs(dnode.props.dryLevel);

    dnode.input.connect(dnode.dryGain);
    dnode.dryGain.connect(dnode.output);

    //the splitter allows downmixing to mono
    dnode.splitter = webAudioContext.context.createChannelSplitter(2);

    dnode.input.connect(dnode.splitter);
    dnode.splitter.connect(dnode.delayLeft, 0, 0);
    dnode.splitter.connect(dnode.delayLeft, 1, 0);

    dnode.delayLeft.connect(dnode.outputMerge, 0, 0);
    dnode.delayLeft.connect(dnode.feedbackLR);
    dnode.feedbackLR.connect(dnode.delayRight);

    dnode.delayRight.connect(dnode.outputMerge, 0, 1);
    dnode.delayRight.connect(dnode.feedbackRL);
    dnode.feedbackRL.connect(dnode.delayLeft);

    dnode.outputMerge.connect(dnode.wetGain);
    dnode.wetGain.connect(dnode.output);

    super.setProps(dnode);
  }

  setDelayTime(dnode) {
    const delayTime = dnode.props.delayTime / 1000;
    dnode.delayLeft.delayTime.value = delayTime;
    dnode.delayRight.delayTime.value = delayTime;
  }

  setVolume(dnode) {
    dnode.output.gain.value = webAudioUtils.dbToJs(dnode.props.volume);
  }
}

const nodePingPongDelayHtml = new NodePingPongDelayHtml(
  "webaudio:node:pingPongDelay"
);
export { nodePingPongDelayHtml, NodePingPongDelayHtml };
